export const tabs =['cities', 'main specialities', 'sub specialities', 'areas', 'area neighbours', 'insurances', 'medical cards'];